enum PersonIds {
  Agent22 = "agent22",
  UsNato = "atlantictrust",
  Unknown = "unknown",
  Wakam = "wakam",
  Hansaeule = "person_hansaeule"
}

export default PersonIds;
